import React from "react";
import { Table, Button, Form } from "react-bootstrap";
import { ErrorMessage } from "formik";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

const yesNoOptions = [
    { value: "Yes", icon: FaCheckCircle, activeVariant: "success", inactiveVariant: "outline-success" },
    { value: "No", icon: FaTimesCircle, activeVariant: "danger", inactiveVariant: "outline-danger" },
];

export default function VerificationChecklistTable({ particularsList, formik, disabled }) {
    return (
        <div className="table-responsive">
            <Table bordered>
                <thead className="table-primary">
                    <tr>
                        <th style={{ width: "5%" }}>S.No</th>
                        <th style={{ width: "35%" }}>Particular Name</th>
                        <th style={{ width: "20%" }}>As Per Norms</th>
                        <th style={{ width: "25%" }}>Remarks</th>
                    </tr>
                </thead>
                <tbody>
                    {particularsList.map((item) => (
                        <tr key={item.fieldName}>
                            <td className="text-center">{item.sno}</td>
                            <td>{item.particular}</td>
                            <td>
                                <div className="d-flex gap-2">
                                    {yesNoOptions.map((option) => {
                                        const Icon = option.icon;
                                        return (
                                            <Button
                                                key={`${item.fieldName}-${option.value}`}
                                                type="button"
                                                size="sm"
                                                disabled={disabled}
                                                variant={formik.values[item.fieldName] === option.value ? option.activeVariant : option.inactiveVariant}
                                                onClick={() => formik.setFieldValue(item.fieldName, option.value)}
                                            >
                                                <Icon /> {option.value}
                                            </Button>
                                        );
                                    })}
                                </div>
                                <ErrorMessage name={item.fieldName} component="div" className="text-danger mt-1" />
                            </td>
                            <td>
                                <Form.Control
                                    as="textarea"
                                    size="sm"
                                    placeholder="Enter remarks..."
                                    name={item.remarksField}
                                    value={formik.values[item.remarksField]}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    disabled={disabled}
                                />
                                <ErrorMessage name={item.remarksField} component="div" className="text-danger mt-1" />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
}
